import { TransactionType } from '@shared/transactions-types';
import { getFeatureConfig } from '@luna/feature-config';

import type { TransactionPredicate } from './types';
import { isType } from './isType';
import { accountingAmountDiffersFromBookingAmount } from './accountingAmountDiffersFromBookingAmount';

export const hasAdditionalDetails: TransactionPredicate = (transaction) => {
    const { addBookingType, addAllTypes } = getFeatureConfig(
        ({ transactions }) => transactions.writtenItems,
    );

    const { additionalTexts, bookingTypeTranslation } = transaction;
    const { text1, lineItems, variableSymbol } = additionalTexts || {};

    const hasText = Boolean(text1);
    const hasLineItems = lineItems?.some(Boolean);
    const hasBookingType = (addBookingType || addAllTypes) && Boolean(bookingTypeTranslation);
    const isSIPOTransaction = isType(TransactionType.SIPO)(transaction);
    const hasSipoVariableSymbol = addAllTypes && isSIPOTransaction && Boolean(variableSymbol);
    const hasAccountingAmount =
        addAllTypes && accountingAmountDiffersFromBookingAmount(transaction);

    return (
        hasText || hasLineItems || hasBookingType || hasSipoVariableSymbol || hasAccountingAmount
    );
};
